import Api from '@/api/Api'
import store from '../store'

export default {

  async getPartnerDiscount (code) {
    return store.dispatch('checkResponseApi', await Api().get(`partners/${code}/discounts`))
  },

}



// WEBPACK FOOTER //
// ./src/api/TSPartnerService.js